export default __webpack_public_path__ + "static/media/bg-experience.bd550ecd.jpg";